import { createParamString, slugify } from '@surfline/web-common';

export const highlightsSharePath = ({
  spotName,
  spotId,
  camId,
  clipIndex,
}: {
  spotName: string;
  spotId: string;
  camId: string;
  clipIndex: number | undefined;
}) =>
  `/share/surf-report/${slugify(spotName)}/${spotId}/rewind?${createParamString({
    ...(clipIndex !== undefined && { clipIndex }),
    camId,
  })}`;

export default highlightsSharePath;
